import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {I18NextNS} from '_/i18n';

import {WizardStepProps} from '../CreateFromTemplateWizard.types';

import {PreviewWrapper} from './PreviewWrapper';

const UEmailPreview = ({
  backLabel,
  nextLabel,
  onBackClick,
  onNextClick,
}: WizardStepProps): React.ReactElement => {
  const {t} = useTranslation<I18NextNS>('communication');
  return (
    <PreviewWrapper
      backLabel={backLabel}
      nextLabel={nextLabel}
      onBackClick={onBackClick}
      onNextClick={onNextClick}
    >
      <InfoText>{t('createFromTemplateWizard.EmailPreview.infoText')}</InfoText>
    </PreviewWrapper>
  );
};
export const EmailPreview = observer(UEmailPreview);

const InfoText = styled.p`
  font-weight: var(--font-weight-thin);
  margin: var(--gutter-big);
`;
